module.exports = __webpack_public_path__ + "img/imagen_parrafo_dos.ba361b0f.jpg";